import type { DocMigration } from "../docMigration";

function migrateRoofFramingSettings(roofFramingSettings: any): any {
  const { startFramingType, endFramingType, eaveFramingType } = roofFramingSettings;
  let newRoofFramingSettings = { ...roofFramingSettings };

  if (startFramingType === "STICK_FRAMING") {
    newRoofFramingSettings = { ...newRoofFramingSettings, startFramingType: "AUTO" };
  }

  if (endFramingType === "STICK_FRAMING") {
    newRoofFramingSettings = { ...newRoofFramingSettings, endFramingType: "AUTO" };
  }

  if (eaveFramingType === "STICK_FRAMING") {
    newRoofFramingSettings = { ...newRoofFramingSettings, eaveFramingType: "AUTO" };
  }

  return newRoofFramingSettings;
}

function migrateRoofEdgeOverride(roofEdgeOverride: any): any {
  const { framingType } = roofEdgeOverride;

  if (framingType === "STICK_FRAMING") {
    return { ...roofEdgeOverride, framingType: "AUTO" };
  }

  return roofEdgeOverride;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_366: DocMigration = {
  maxSchemaVersion: "0.0.366",
  description: "New auto mode for roof wall framing",
  apply(json: any) {
    // migrate global settings
    for (const settingsId in json.settings) {
      const setting = json.settings[settingsId];

      if (setting.type === "ROOF_FRAMING_SETTINGS") {
        json.settings[settingsId] = migrateRoofFramingSettings(setting);
      }
    }

    // migrate roofs
    for (const roofId in json.roofs) {
      const { roofSettings, roofSideOverrides = {}, roofEdgeOverrides = {} } = json.roofs[roofId];

      // migrate roof instance settings
      if (roofSettings) {
        json.roofs[roofId].roofSettings = migrateRoofFramingSettings(roofSettings);
      }

      // migrate roof side overrides
      for (const sideId in roofSideOverrides) {
        json.roofs[roofId].roofSideOverrides[sideId] = migrateRoofEdgeOverride(roofSideOverrides[sideId]);
      }

      // migrate roof edge overrides
      for (const edgeId in roofEdgeOverrides) {
        json.roofs[roofId].roofEdgeOverrides[edgeId] = migrateRoofEdgeOverride(roofEdgeOverrides[edgeId]);
      }
    }

    return json;
  },
};

export default migration_0_0_366;
